import { deleteCookiesByPrefix, loadScript, removeScript } from '@/shared/lib/analytics/scriptLoader'
import {
  configString,
  type AnalyticsEventProps,
  type AnalyticsProvider,
  type AnalyticsProviderConfig,
} from '@/shared/lib/analytics/types'

const SCRIPT_ID = 'cse-analytics-matomo'
const COOKIE_PREFIXES = ['_pk_', 'mtm_', 'matomo_'] as const

function eventLabel(props: AnalyticsEventProps | undefined): string | undefined {
  if (props === undefined) {
    return undefined
  }
  const label = Object.entries(props)
    .map(([key, value]) => `${key}=${String(value)}`)
    .join(';')

  return label === '' ? undefined : label
}

export function createMatomoProvider(): AnalyticsProvider {
  return {
    key: 'matomo',
    load(config: AnalyticsProviderConfig): void {
      const baseUrl = configString(config, 'base_url')
      const paq = (window._paq ??= [])
      paq.push(['setDoNotTrack', true])
      if (config.cookieless === true) {
        paq.push(['disableCookies'])
      }
      paq.push(['setTrackerUrl', `${baseUrl}matomo.php`])
      paq.push(['setSiteId', configString(config, 'site_id')])
      loadScript(SCRIPT_ID, `${baseUrl}matomo.js`).catch(() => undefined)
    },
    unload(): void {
      removeScript(SCRIPT_ID)
      delete window._paq
      deleteCookiesByPrefix(COOKIE_PREFIXES)
    },
    pageview(path: string): void {
      const paq = (window._paq ??= [])
      paq.push(['setCustomUrl', `${window.location.origin}${path}`])
      paq.push(['setDocumentTitle', document.title])
      paq.push(['trackPageView'])
    },
    track(name: string, props?: AnalyticsEventProps): void {
      const paq = (window._paq ??= [])
      paq.push(['trackEvent', 'app', name, eventLabel(props)])
    },
  }
}
